/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { InjectionToken } from '@angular/core';

export const ORIGIN_URL = new InjectionToken<any>('ORIGIN_URL');
export const REQUEST = new InjectionToken<any>('REQUEST');
export const RESPONSE = new InjectionToken<any>('RESPONSE');
